// The ladder law, mirrored client-side so the panel can refuse a broken
// ladder BEFORE the save round-trip (the service enforces the same rules —
// domains/platform/waitlist/src/settings.ts is the authority): bands cover
// every coin count with no gaps and no overlaps, start at 0, exactly one
// open-ended top band.
export const ladderProblems = bands => {
  if (!bands.length) return ['the prize ladder needs at least one band'];
  const problems = [];
  const parsed = bands.map((band, index) => ({
    index,
    from: Number(band.fromCoins),
    to: band.toCoins === '' || band.toCoins === undefined ? undefined : Number(band.toCoins),
    itemId: band.itemId,
  }));
  for (const band of parsed) {
    if (!Number.isInteger(band.from) || band.from < 0) {
      problems.push(`band ${band.index + 1}: "from Jelly" must be a whole number`);
    }
    if (band.to !== undefined && (!Number.isInteger(band.to) || band.to < band.from)) {
      problems.push(
        `band ${band.index + 1}: "to Jelly" must be a whole number at or above its start`
      );
    }
    if (!band.itemId) {
      problems.push(`band ${band.index + 1}: pick a box item`);
    }
  }
  if (problems.length) return problems;

  const sorted = [...parsed].sort((a, b) => a.from - b.from);
  if (sorted[0].from !== 0) problems.push('the ladder must start at 0 Jelly');
  sorted.forEach((band, index) => {
    const isLast = index === sorted.length - 1;
    if (isLast && band.to !== undefined) {
      problems.push('the top band must be open-ended (leave "to Jelly" empty)');
    }
    if (!isLast) {
      if (band.to === undefined) {
        problems.push('only the top band may be open-ended');
      } else if (sorted[index + 1].from !== band.to + 1) {
        problems.push('bands must cover every coin count with no gaps and no overlaps');
      }
    }
  });
  return problems;
};

/** Waves derive from the audit trail: every close writes a wave-close row
 *  (target = the wave's uuid, reason = "name · summary" — the ' · '
 *  separator is the service's contract with this panel, so closed waves
 *  show NAMES, never uuids). */
export const wavesFromAudit = actions =>
  (actions ?? [])
    .filter(action => action.action === 'wave-close')
    .map(action => {
      const split = (action.reason ?? '').split(' · ');
      return {
        waveId: action.target,
        name: split.length > 1 ? split[0] : action.target,
        at: action.at,
        by: action.actor,
        summary: split.length > 1 ? split.slice(1).join(' · ') : action.reason ?? '',
      };
    });

/** COHORT WAVES: the audit rows that belong to one wave's story — rows
 *  targeting the wave itself (settings edits, its close), rows targeting
 *  its cohort's accounts (freeze/unfreeze/revoke), and mint rows whose
 *  batch was stamped with this wave. */
